<div class="ion-margin" *ngIf="errors.length">
  <p class="error" *ngFor="let error of errors">
    <ion-icon name="alert-circle-outline"></ion-icon> {{error}}
  </p>
</div>
